import { render, staticRenderFns } from "./DodDashboard.vue?vue&type=template&id=4982c7ae&"
import script from "./DodDashboard.vue?vue&type=script&lang=js&"
export * from "./DodDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports